import { isoDate, zonedTimeToEpoch } from '@petrhythm/core';

export const KST = 'Asia/Seoul';

/** 보호자가 적은 이름이나 단위 뒤에 목적격 조사를 붙인다. */
export function withObjectParticle(value: string): string {
  const text = value.trim();
  const last = text.at(-1) ?? '';
  const code = last.charCodeAt(0) - 0xac00;
  const hasFinal = code >= 0 && code <= 11171 ? code % 28 !== 0 : '013678'.includes(last) && last !== '';
  return `${text}${hasFinal ? '을' : '를'}`;
}

export function todayKst(): string {
  return isoDate(Date.now(), KST);
}

export function formatDateTime(value: number): string {
  return new Intl.DateTimeFormat('ko-KR', { timeZone: KST, month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(value));
}

export function formatDate(value: number): string {
  return new Intl.DateTimeFormat('ko-KR', { timeZone: KST, year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(value));
}

export function formatTime(value: number): string {
  return new Intl.DateTimeFormat('ko-KR', { timeZone: KST, hour: '2-digit', minute: '2-digit' }).format(new Date(value));
}

export function dateToEpoch(date: string, endOfDay = false): number {
  const epoch = zonedTimeToEpoch(date, endOfDay ? '23:59' : '00:00', KST);
  return endOfDay ? epoch + 59_999 : epoch;
}

export function daysAgo(days: number): string {
  const base = new Date(`${todayKst()}T00:00:00Z`);
  base.setUTCDate(base.getUTCDate() - days);
  return base.toISOString().slice(0, 10);
}

const KRW = new Intl.NumberFormat('ko-KR');

/** 모든 금액 표기는 이 함수 하나로 "46,000원" 형식을 쓴다. */
export function formatKrw(amount: number): string {
  return `${KRW.format(Math.round(amount))}원`;
}

/** 오늘 화면 머리말처럼 사람이 읽는 날짜: "10월 16일 목요일". */
export function formatLongDay(date: string): string {
  return new Intl.DateTimeFormat('ko-KR', { timeZone: 'UTC', month: 'long', day: 'numeric', weekday: 'long' }).format(new Date(`${date}T00:00:00Z`));
}

/** "10월 16일" 짧은 날짜(ISO date 입력). */
export function formatShortDay(date: string): string {
  return new Intl.DateTimeFormat('ko-KR', { timeZone: 'UTC', month: 'long', day: 'numeric' }).format(new Date(`${date}T00:00:00Z`));
}

/** ISO date에 일 수를 더한다(KST 달력일 기준, 시간대 없음). */
export function addDays(date: string, days: number): string {
  const base = new Date(`${date}T00:00:00Z`);
  base.setUTCDate(base.getUTCDate() + days);
  return base.toISOString().slice(0, 10);
}

/** epoch를 KST 달력일로. */
export function kstDate(epoch: number): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: KST, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(epoch));
}
